import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@mui/material/Button';
import React, { useContext } from 'react';

import { ChartInteractionConfirmDialogContext } from 'src/nightingale/components/ChartInteraction/ChartInteractionConfirmDialogContext';

export const ChartInteractionConfirmDialog = () => {
  const {
    isOpen,
    content: { title, message, onConfirm, onCancel, prompt },
    hideDialog,
  } = useContext(ChartInteractionConfirmDialogContext);

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    hideDialog();
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    hideDialog();
  };

  return (
    <Dialog open={isOpen ?? false} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent style={{ whiteSpace: 'pre-line' }}>
        {message}
        <div style={{ fontWeight: 'bold', marginTop: 32, justifySelf: 'flex-end', width: '75%' }}>
          {prompt}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>No</Button>
        <Button onClick={handleConfirm}>Yes</Button>
      </DialogActions>
    </Dialog>
  );
};
